'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useMemo } from 'react';
import { styled } from 'styled-components';
import { ListContainer } from './elements';
import { ListItem } from './ListItem';
const HiddenAriaText = styled.div.withConfig({
  componentId: "aui__sc-179slkf-0"
})(["height:0;opacity:0;position:absolute;"]);
export const ProgressStepper = /*#__PURE__*/forwardRef(({
  steps,
  size,
  orientation,
  isPacked,
  ...rest
}, fRef) => {
  const ariaLabel = useMemo(() => {
    var _currentStep$subSteps, _currentStep$subSteps2;
    const currentStepIndex = steps.map(step => step.state !== 'incomplete').lastIndexOf(true);
    const currentStep = steps[currentStepIndex];
    const label = `step ${currentStepIndex + 1} out of ${steps.length}`;
    if (!(currentStep !== null && currentStep !== void 0 && (_currentStep$subSteps = currentStep.subSteps) !== null && _currentStep$subSteps !== void 0 && _currentStep$subSteps.length)) {
      return label;
    }
    if (currentStep.state === 'inprogress') {
      return `${label} part 1`;
    }
    const subStepIndex = (_currentStep$subSteps2 = currentStep.subSteps) === null || _currentStep$subSteps2 === void 0 ? void 0 : _currentStep$subSteps2.findIndex(subStep => subStep.state === 'inprogress');
    if (subStepIndex !== undefined) {
      return `${label} part ${subStepIndex + 2}`;
    }
    return label;
  }, [steps]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenAriaText, null, ariaLabel), /*#__PURE__*/React.createElement(ListContainer, _extends({
    "data-aui": "progress-stepper",
    ref: fRef,
    "aria-hidden": true,
    "data-testid": "progress-stepper",
    orientation: orientation
  }, rest), steps.map((step, index) => /*#__PURE__*/React.createElement(ListItem, _extends({}, step, {
    key: index,
    index: index,
    stepsAmount: steps.length,
    size: size,
    orientation: orientation,
    isPacked: isPacked
  })))));
});